import { useNavigate } from 'react-router-dom';

interface Props {
  title?: string;
  message?: string;
  backTo?: string;
  inline?: boolean;
}

export function ForbiddenPage({
  title = 'Zugriff verweigert',
  message = 'Sie haben keine Berechtigung, auf diesen Bereich zuzugreifen.',
  backTo,
  inline = false,
}: Props) {
  const navigate = useNavigate();

  const content = (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '3rem 1.5rem',
      textAlign: 'center',
      gap: '1rem',
    }}>
      <div style={{
        width: 64, height: 64, borderRadius: '50%',
        background: '#fee2e2',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '1.75rem',
      }}>
        🔒
      </div>
      <h2 style={{ fontSize: '1.25rem', fontWeight: 700, margin: 0, color: 'var(--color-text)' }}>
        {title}
      </h2>
      <p style={{ fontSize: '0.9rem', color: 'var(--color-text-muted)', maxWidth: 420, margin: 0 }}>
        {message}
      </p>
      <div style={{ display: 'flex', gap: '0.75rem', marginTop: '0.5rem' }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            padding: '0.5rem 1rem', border: '1px solid var(--color-border)',
            borderRadius: '6px', background: 'transparent',
            color: 'var(--color-text)', cursor: 'pointer', fontSize: '0.875rem',
          }}
        >
          Zurück
        </button>
        {backTo && (
          <button
            onClick={() => navigate(backTo)}
            style={{
              padding: '0.5rem 1rem', border: '1px solid var(--color-primary)',
              borderRadius: '6px', background: 'var(--color-primary)',
              color: '#fff', cursor: 'pointer', fontSize: '0.875rem',
            }}
          >
            Zur Startseite
          </button>
        )}
      </div>
    </div>
  );

  if (inline) return content;

  return (
    <div style={{
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      {content}
    </div>
  );
}
